"use client";
import AiReferralTracker from "./AiReferralTracker";
import { useEffect, useRef } from "react";
export default function ArticleReadTracker({ articleId, edition = "" }) {
  const sent = useRef(null);
  useEffect(() => {
    const record=()=>{
      if(document.visibilityState !== "visible" || sent.current===articleId) return;
      sent.current=articleId;
      fetch("/api/article-read"+(edition ? "?edition="+encodeURIComponent(edition) : ""),{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({articleId,eventId:crypto.randomUUID()}),keepalive:true}).catch(()=>{});
    };
    record(); document.addEventListener("visibilitychange",record);
    return ()=>document.removeEventListener("visibilitychange",record);
  },[articleId,edition]);
  return <AiReferralTracker articleId={articleId} edition={edition} />;
}
